import React, { Fragment } from "react";
import moment from "moment";
import { baseApiUrl } from "api";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { withStyles } from "material-ui/styles";
import { fade } from "material-ui/styles/colorManipulator";
import classnames from "classnames";
import {
  Button,
  Paper,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails
} from "material-ui";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import BackButton from "components/BackButton";
import ErrorMessage from "components/ErrorMessage";
import CTable, {
  CTableHead,
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";
import CInput from "uis/CInput";
import lime from "material-ui/colors/lime";
import { isAdmin, pathRole, fmtIndustryName } from "utils/formatter";
import storage from "utils/storage";
import SelectIndustryModal from "./SelectIndustryModal";
import SelectIndustryByAttrModal from "./SelectIndustryByAttrModal";
import DatePicker from "uis/Datepicker";
import { Typography } from "@material-ui/core";

const styles = theme => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0
  },
  main: {
    padding: 20
  },
  errorMessages: {
    margin: "10px 20px 0"
  },
  exportCSV: {
    float: "right",
    marginTop: 6
  },
  reportInfo: {
    borderBottom: "1px solid lightgray",
    paddingBottom: 10
  },
  paperRow: {
    padding: "10px 15px"
  },
  surveyUrlPaperRow: {
    padding: "15px 15px 0"
  },
  paperDesc: {
    color: "#9699a2",
    fontSize: "1rem",
    fontWeight: 300,
    marginTop: 10
  },
  paperValue: {
    color: "#575962",
    marginTop: "0.1rem",
    marginLeft: "1.5rem",
    display: "inline-block",
    fontSize: "1.1rem",
    fontWeight: 600
  },
  paperPeriod: {
    color: "#575962",
    marginTop: "0.1rem",
    margin: "0 1rem",
    display: "inline-block",
    fontSize: "0.9rem",
    fontWeight: 600
  },
  paperHeader: {
    padding: "1rem 1.8rem .5rem",
    color: "#575962",
    fontSize: "1.1rem",
    fontWeight: 600,
    borderBottom: "3px solid #ebedf2",
    marginBottom: "1rem"
  },
  paperHeader2: {
    padding: "1rem 1.8rem",
    color: "#575962",
    textAlign: "center",
    fontSize: "1rem",
    fontWeight: 100,
    borderBottom: "2px solid #ebedf2"
  },
  paperContent: {
    padding: "0 1.8rem"
  },
  centerPaperContent: {
    padding: "2rem 1.8rem 1rem",
    textAlign: "center"
  },
  paperCard: {
    height: 200,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: fade("#2196F3", 0.1),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  },
  paperDisabled: {
    height: 200,
    backgroundColor: "rgba(0, 0, 0, 0.12)"
  },
  paperIcon: {
    fontSize: 80,
    color: "#2196F3"
  },
  statusLabel: {
    borderRadius: 15,
    color: "white",
    padding: "2px 15px",
    fontWeight: "normal"
  },
  statusBtn: {
    marginRight: 10
  },
  statusActions: {
    marginLeft: 40,
    display: "inline-block"
  },
  basicInfoLabel: {
    float: "left",
    marginTop: 7
  },
  editBtn: {
    float: "right"
  },
  basicInfoPaperWrapper: {
    marginBottom: "2rem",
    paddingBottom: 0
  },
  basicInfoPaper: {
    marginBottom: 20,
    position: "relative",
    height: 330
  },
  surveyLocale: {
    height: 290,
    overflowY: "scroll"
  },
  btnNavActionRoot: {
    maxWidth: "none"
  },
  soloLocale: {
    pointerEvents: "none"
  },
  selectedNavItem: {
    color: "#fff",
    backgroundColor: "#26a69a"
  },
  employeesInfo: {
    borderBottom: "1px solid lightgray"
  },
  termInfo: {
    borderBottom: "1px solid lightgray"
  },
  copyBtn: {},
  adminPaperContent: {
    marginBottom: 20
  },
  imageSize: {
    height: 80,
    width: 80
  },
  clear: {
    clear: "both"
  },
  reportName: {
    paddingLeft: "1rem"
  },
  chapter: {
    paddingLeft: "2rem"
  },
  pdfButton: {
    padding: 0,
    minHeight: "0px"
  },
  deleteBtn: {
    backgroundColor: theme.palette.remove.dark,
    "&:hover": {
      backgroundColor: theme.palette.remove.light
    }
  },
  warning: {
    color: "#ff2212",
    fontSize: "1.5rem",
    fontWeight: 600
  }
});

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAttr: null,
      termFrom: null,
      error: false,
      isChecked: false,
    };
  }

  componentWillMount() {
    this.props.fetchReport();
    window.scroll(0, 0);
  }

  componentDidUpdate(prevProps) {
    const currentReportStatus = this.props.report.reportStatus;
    if (prevProps.report.reportStatus.reportDate !== this.props.report.reportStatus.reportDate) {
      if (this.props.report.reportStatus.reportDate !== null) {
        this.setState({
          isChecked: true,
          termFrom: new Date(this.props.report.reportStatus.reportDate)
        });
      } else {
        this.setState({
          isChecked: false,
          termFrom: null
        });
      }
    }
    if (!prevProps.report.editStatus && this.props.report.editStatus) {
      this.setState({
      initialReportStatus: currentReportStatus.toJS(),
      initialAttrData: this.props.report.surveyAttrs.map(attr => ({
        ...attr,
        items: attr.items.map(item => ({ ...item }))
      }))
    });
  }
  }

  componentDidMount() {
  const clonedAttrs = JSON.parse(JSON.stringify(this.props.report.surveyAttrs));
  this.setState({ initialAttrData: clonedAttrs });
  }

  componentWillUnmount() {
    this.props.initReport();
  }

  handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    this.setState({
      isChecked,
      termFrom: isChecked ? this.state.termFrom : null,
    });
  };


  resetAttrCheckboxes = () => {
    const { initialAttrData } = this.state;

    if (!Array.isArray(initialAttrData)) {
      return;
    }

    initialAttrData.forEach((attr, attrIndex) => {
      if (!Array.isArray(attr.items)) return;

      attr.items.forEach((item, itemIndex) => {
         const checkboxIndices = [
            ...Array.from({ length: 11 }, (_, i) => i + 5),
            18, 19, 20
          ];
      checkboxIndices.forEach(arr => {
              const savedVal = item[arr];
              this.props.changeReportByAttrStatus({
                attrIndex,
                itemIndex,
                arr,
                val: savedVal
              });
            });
      });
    });
  };

  render() {
    const { classes, report, getCSV, getAttrCSV } = this.props;
    const {
      survey,
      customer,
      reportStatus,
      latestUpdateHistory,
      surveyAttrs,
      editStatus,
      loading,
      industries,
      isOpenIndustryModal,
      isOpenIndustryByAttrModal,
      modalIndustryParentId,
      modalIndustryId,
    } = report;
    const { errors } = report;
    if (!survey.id) {
      return null;
    }
    const attrItems = [];
    surveyAttrs.forEach((attr) => {
      attr.items.forEach((item) => {
        const obj = {};
        Object.assign(obj, {
          id: item[0],
          name: item[1]
        });
        attrItems.push(obj);
      });
    });
    const selectAttrItem = (e) => {
      this.setState({
        selectedAttr: e.target.value
      });
    };
    const surveyId = this.props.match.params.id;
    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>レポート</h2>
          <BackButton />
        </div>

        <ErrorMessage messages={errors} className={classes.errorMessages} />

        <div className={classes.main}>
          <div
            className={classes.paperHeader}
            style={{
              justifyContent: "space-between",
              display: "flex",
              alignItems: "flex-end"
            }}
          >
            <div>基本情報</div>
            {isAdmin() && (
              <div>
                <div className={classes.paperDesc}>レポート状態</div>
                <div>
                  <div className={classes.paperValue}>
                    {reportStatus.isRelease ? (
                      <div
                        className={classes.statusLabel}
                        style={{ backgroundColor: "#009688" }}
                      >
                        公開
                      </div>
                    ) : (
                      <div
                        className={classes.statusLabel}
                        style={{ backgroundColor: lime[700] }}
                      >
                        未公開
                      </div>
                    )}
                  </div>

                  <div className={classes.statusActions}>
                    <Button
                      dense
                      raised
                      disabled={reportStatus.isRelease}
                      className={classes.statusBtn}
                      onClick={() =>
                        this.props.publicRelease({
                          isRelease: true
                        })
                      }
                    >
                      顧客へ公開する
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            className={classnames(
              classes.paperContent,
              classes.basicInfoPaperWrapper
            )}
          >
            <div className={classes.paperDesc}>会社名</div>
            <div className={classes.paperValue}>
              {customer.customerName} ( ID: {customer.customerKey})
            </div>
            <div className={classes.paperDesc}>アンケート名</div>
            <div className={classes.paperValue}>{survey.surveyName}</div>
            <div className={classes.paperDesc}>公開期間</div>
            <div className={classes.paperValue}>{survey.termFmt()}</div>
            {!isAdmin() && reportStatus.reportDate && (
                <div>
                  <div className={classes.paperDesc}>レポート日付</div>
                    <div className={classes.paperValue}>{moment(reportStatus.reportDate).format('YYYY年MM月DD日')}
                    </div>
                </div>
            )}
          </div>

          <div
            className={classes.paperHeader}
            style={{
              justifyContent: "space-between",
              display: "flex",
              alignItems: "flex-end"
            }}
          >
            <div>レポート目次</div>
            {isAdmin() && (
              <div style={{ marginLeft: 60 }}>
                {editStatus ? (
                  <div>
                    <Button
                      dense
                      raised
                      className={classes.deleteBtn}
                      onClick={() => {
                         this.setState({
                          isChecked: false,
                          termFrom: null,
                        });
                         this.props.changeReportStatus(this.state.initialReportStatus, 'cancel');
                         this.resetAttrCheckboxes();
                        this.props.changeEditStatus(false);
                      }}
                    >
                      キャンセル
                    </Button>
                    <Button
                      dense
                      raised
                      className={classes.statusBtn}
                      style={{ marginLeft: 30 }}
                      onClick={() =>
                        this.props.updateReportStatus(reportStatus, surveyAttrs, this.state.isChecked , this.state.termFrom)
                      }
                    >
                      更新
                    </Button>
                  </div>
                ) : (
                  <Button
                    dense
                    raised
                    className={classes.statusBtn}
                    onClick={() =>
                      this.props.changeEditStatus(!this.props.editStatus)
                    }
                  >
                    出力設定を編集
                  </Button>
                )}
              </div>
            )}
          </div>
          <div
            className={classnames(
              classes.paperContent,
              classes.basicInfoPaperWrapper
            )}
          >
            {isAdmin() && (
              <div>
                <div className={classes.paperDesc}>表紙の様式</div>
                <div
                  style={{
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: "flex-end"
                  }}
                >
                  <div style={{ margin: "10px 30px" }}>
                    <Select
                      value={reportStatus.itemId}
                      disabled={!editStatus}
                      onChange={e =>
                        this.props.changeReportStatus({
                          itemId: e.target.value
                        })
                      }
                      input={
                        <CInput
                          name="industry-type"
                          id="industry-type"
                          className={classes.industryInput}
                        />
                      }
                    >
                      {[
                        { id: 1, name: "（公財）日本生産性本部" },
                        { id: 2, name: "東京中小企業投資育成株式会社" }
                      ].map(item => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ margin: "13px 0px" }}>属性項目:</div>
                    <Select
                      value={this.state.selectedAttr}
                      style={{ margin: "10px", width: "150px" }}
                      onChange={selectAttrItem}
                      input={
                        <CInput
                          name="industry-type"
                          id="industry-type"
                          className={classes.industryInput}
                        />
                      }
                    >
                      {
                        attrItems.map(item => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))
                      }
                    </Select>
                    <Button
                      className={classes.statusBtn}
                      disabled={!this.state.selectedAttr || loading}
                      onClick={
                        () => this.props.generateAttrReport(surveyId, this.state.selectedAttr)
                      }
                    > 属性項目別レポートを作成する
                    </Button>
                  </div>
                </div>
                <div style={{ marginLeft: 20, margin: "10px 213px", display:'flex', alignItems: 'center', justifyContent:'flex-end'}}>
                  <Typography
                    variant="body1"
                    style={{
                      color: !editStatus
                      ? 'rgba(0, 0, 0, 0.38)'
                      : 'rgba(0, 0, 0, 0.87)',
                    }}
                  >
                  レポート日付:
                  </Typography>
                  <Checkbox
                    checked={this.state.isChecked}
                    onChange={this.handleCheckboxChange}
                    style={{ height: 30 }}
                    disabled={!editStatus}
                  />
                  <div style={{ display: 'flex', alignItems:'center'}}>
                      <DatePicker
                        hideTime={true}
                        selectedDate = {this.state.termFrom}
                        disabled={!editStatus || !this.state.isChecked}
                        onChange={(date) => this.setState({ termFrom: date, error: false })}
                      />
                    </div>
                </div>
              </div>
            )}
            <ExpansionPanel defaultExpanded>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} >
                  全体
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <CTable>
                  <CTableHead>
                    <CTableRow>
                      <CHeadCell>目次</CHeadCell>
                      {isAdmin() && (
                        <Fragment>
                          <CHeadCell style={{ width: 140 }}>更新者</CHeadCell>
                          <CHeadCell style={{ width: 160 }}>更新日</CHeadCell>
                        </Fragment>
                      )}
                      <CHeadCell style={{ width: 100 }}>レポート出力</CHeadCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    <CTableRow>
                      <CBodyCell className={classes.reportName}>
                        {reportStatus.isFinish() ? (
                          <HashLink to={`/${pathRole()}/report_detail/${surveyId}`}>
                            NiserES 調査結果レポート
                          </HashLink>
                        ) : (
                          <span>NiserES 調査結果レポート</span>
                        )}
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell />
                          <CBodyCell />
                        </Fragment>
                      )}

                      <CBodyCell align="center">
                        {reportStatus.isFinish() && (
                          <Button
                            className={classes.pdfButton}
                            disabled={editStatus}
                            onClick={() =>
                              window.open(
                                `${baseApiUrl()}/${pathRole()}/report_detail/${surveyId}/pdf.pdf?debug=false&token=${storage.getToken()}`
                              )
                            }
                          >
                            <i className="material-icons">picture_as_pdf</i>
                          </Button>
                        )}
                      </CBodyCell>
                    </CTableRow>
                    <CTableRow>
                      <CBodyCell className={classes.chapter}>
                        {reportStatus.isFinish() ? (
                          <HashLink
                            to={`/${pathRole()}/report_detail/${surveyId}#description`}
                          >
                            １．調査概要
                          </HashLink>
                        ) : (
                          <span>１．調査概要</span>
                        )}
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell />
                          <CBodyCell />
                        </Fragment>
                      )}

                      <CBodyCell />
                    </CTableRow>
                    <CTableRow>
                      <CBodyCell className={classes.chapter}>
                        {reportStatus.isFinish() ? (
                          <HashLink
                            to={`/${pathRole()}/report_detail/${surveyId}#summary`}
                          >
                            ２．結果のまとめ
                          </HashLink>
                        ) : (
                          <span>２．結果のまとめ</span>
                        )}
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell>
                            {latestUpdateHistory[1] &&
                              latestUpdateHistory[1].updateAdmin.adminName}
                          </CBodyCell>
                          <CBodyCell center>
                            {latestUpdateHistory[1] &&
                              moment(latestUpdateHistory[1].updateDt).format(
                                "YYYY/MM/DD"
                              )}
                          </CBodyCell>
                        </Fragment>
                      )}
                      <CBodyCell />
                    </CTableRow>
                    <CTableRow>
                      <CBodyCell className={classes.chapter}>
                        {reportStatus.isFinish() ? (
                          <HashLink
                            to={`/${pathRole()}/report_detail/${surveyId}#overall_result`}
                          >
                            ３．全体の尺度別設問の結果
                          </HashLink>
                        ) : (
                          <span>３．全体の尺度別設問の結果</span>
                        )}
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell />
                          <CBodyCell />
                        </Fragment>
                      )}
                      <CBodyCell />
                    </CTableRow>
                    <CTableRow>
                      <CBodyCell className={classes.chapter}>
                        {reportStatus.isFinish() ? (
                          <HashLink
                            to={`/${pathRole()}/report_detail/${surveyId}#attr_result`}
                          >
                            ４．属性別尺度の結果
                          </HashLink>
                        ) : (
                          <span>４．属性別尺度の結果</span>
                        )}
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell />
                          <CBodyCell />
                        </Fragment>
                      )}
                      <CBodyCell />
                    </CTableRow>
                    <CTableRow>
                      <CBodyCell className={classes.reportName}>
                        {/* <Link to="/member/list">NiserES 調査結果 添付資料</Link> */}
                        NiserES 調査結果 添付資料
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell />
                          <CBodyCell />
                        </Fragment>
                      )}
                      <CBodyCell />
                    </CTableRow>
                    <CTableRow>
                      <CBodyCell className={classes.chapter}>
                        {reportStatus.isFinish() ? (
                          <Link to={`/${pathRole()}/basic_report/${surveyId}`}>
                            １．属性別集計結果 Q1~Q63
                          </Link>
                        ) : (
                          <span>１．属性別集計結果 Q1~Q63</span>
                        )}
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell />
                          <CBodyCell />
                        </Fragment>
                      )}
                      <CBodyCell align="center">
                        {reportStatus.isFinish() && (
                          <Button
                            className={classes.pdfButton}
                            disabled={editStatus}
                            onClick={() =>
                              window.open(
                                `${baseApiUrl()}/${pathRole()}/basic_report/${surveyId}/pdf.pdf?debug=false&token=${storage.getToken()}`
                              )
                            }
                          >
                            <i className="material-icons">picture_as_pdf</i>
                          </Button>
                        )}
                      </CBodyCell>
                    </CTableRow>
                    {survey.additionCount > 0 && (
                      <CTableRow>
                        <CBodyCell className={classes.chapter}>
                          {reportStatus.isFinish() ? (
                            <Link to={`/${pathRole()}/original_report/${surveyId}`}>
                              ２．属性別集計結果 Q64~
                            </Link>
                          ) : (
                            <span>２．属性別集計結果 Q64~</span>
                          )}
                        </CBodyCell>
                        {isAdmin() && (
                          <Fragment>
                            <CBodyCell />
                            <CBodyCell />
                          </Fragment>
                        )}
                        <CBodyCell align="center">
                          {reportStatus.isFinish() && (
                            <Button
                              className={classes.pdfButton}
                              disabled={editStatus}
                              onClick={() =>
                                window.open(
                                  `${baseApiUrl()}/${pathRole()}/original_report/${surveyId}/pdf.pdf?debug=false&token=${storage.getToken()}`
                                )
                              }
                            >
                              <i className="material-icons">picture_as_pdf</i>
                            </Button>
                          )}
                        </CBodyCell>
                      </CTableRow>
                    )}
                    <CTableRow>
                      <CBodyCell className={classes.chapter}>
                        {reportStatus.isFinish() ? (
                          <Link
                            to={`/${pathRole()}/result_index_report/${surveyId}`}
                          >
                            ３．質問別結果指数 一覧
                          </Link>
                        ) : (
                          <span>３．質問別結果指数 一覧</span>
                        )}
                        {isAdmin() && (
                          <div style={{ marginLeft: 10, fontSize: '0.8rem' }}>
                            <div style={{ marginLeft: 20, marginTop: 5 }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!reportStatus.diffAll}
                                    disabled={!editStatus}
                                    onChange={e =>
                                      this.props.changeReportStatus({
                                        diffAll: e.target.checked
                                      })
                                    }
                                    style={{ height: 30 }}
                                  />
                                }
                                label="全体"
                              />
                            </div>

                            <div style={{ marginTop: 10 }}>時系列:</div>
                            <div style={{ display: 'flex' }}>
                              <div style={{ marginLeft: 20, marginTop: 5 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={!!reportStatus.diffTime1}
                                      disabled={!editStatus}
                                      onChange={e =>
                                        this.props.changeReportStatus({
                                          diffTime1: e.target.checked
                                        })
                                      }
                                      style={{ height: 30 }}
                                    />
                                  }
                                  label="１回前"
                                />
                              </div>
                              <div style={{ marginLeft: 20, marginTop: 5 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={!!reportStatus.diffTime2}
                                      disabled={!editStatus}
                                      onChange={e =>
                                        this.props.changeReportStatus({
                                          diffTime2: e.target.checked
                                        })
                                      }
                                      style={{ height: 30 }}
                                    />
                                  }
                                  label="２回前"
                                />
                              </div>
                              <div style={{ marginLeft: 20, marginTop: 5 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={!!reportStatus.diffTime3}
                                      disabled={!editStatus}
                                      onChange={e =>
                                        this.props.changeReportStatus({
                                          diffTime3: e.target.checked
                                        })
                                      }
                                      style={{ height: 30 }}
                                    />
                                  }
                                  label="３回前"
                                />
                              </div>
                            </div>

                            <div style={{ marginTop: 10 }}>業種:</div>
                            <div style={{ display: 'flex' }}>
                              <div style={{ marginLeft: 20 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={!!reportStatus.diffManufacture}
                                      disabled={!editStatus}
                                      onChange={e =>
                                        this.props.changeReportStatus({
                                          diffManufacture: e.target.checked
                                        })
                                      }
                                      style={{ height: 30 }}
                                    />
                                  }
                                  label="製造業"
                                />
                              </div>
                              <div style={{ marginLeft: 20 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={!!reportStatus.diffNonManufacture}
                                      disabled={!editStatus}
                                      onChange={e =>
                                        this.props.changeReportStatus({
                                          diffNonManufacture: e.target.checked
                                        })
                                      }
                                      style={{ height: 30 }}
                                    />
                                  }
                                  label="非製造業"
                                />
                              </div>
                            </div>

                            <div style={{ marginTop: 10 }}>企業規模:</div>
                            <div style={{ display: 'flex' }}>
                              <div style={{ marginLeft: 20 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={!!reportStatus.diffBigCorp}
                                      disabled={!editStatus}
                                      onChange={e =>
                                        this.props.changeReportStatus({
                                          diffBigCorp: e.target.checked
                                        })
                                      }
                                      style={{ height: 30 }}
                                    />
                                  }
                                  label="大企業"
                                />
                              </div>
                              <div style={{ marginLeft: 20 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={!!reportStatus.diffSmallCorp}
                                      disabled={!editStatus}
                                      onChange={e =>
                                        this.props.changeReportStatus({
                                          diffSmallCorp: e.target.checked
                                        })
                                      }
                                      style={{ height: 30 }}
                                    />
                                  }
                                  label="中小企業"
                                />
                              </div>
                            </div>

                            <div style={{ marginTop: 10 }}>産業分類:</div>
                            <SelectIndustryModal
                              open={isOpenIndustryModal}
                              industries={industries}
                              changeIndustryForm={null}
                              handleClose={this.props.handleCloseModal}
                              handleChange={this.props.handleChange}
                              handleDecide={this.props.handleDecide}
                              industryParentId={modalIndustryParentId}
                              industryId={modalIndustryId}
                            />
                            <SelectIndustryByAttrModal
                              open={isOpenIndustryByAttrModal}
                              industries={industries}
                              changeIndustryForm={null}
                              handleClose={this.props.handleCloseByAttrModal}
                              handleChange={this.props.handleChange}
                              handleDecide={this.props.handleDecideByAttr}
                              industryParentId={modalIndustryParentId}
                              industryId={modalIndustryId}
                            />
                            <div style={{ marginLeft: 20, marginTop: 5, display: 'flex' }}>
                              <FormControlLabel
                                style={{ marginRight: 2 }}
                                control={
                                  <Checkbox
                                    checked={!!reportStatus.diffIndustry1}
                                    disabled={!editStatus}
                                    onChange={e =>
                                      this.props.changeReportStatus({
                                        diffIndustry1: e.target.checked
                                      })
                                    }
                                    style={{ height: 30 }}
                                  />
                                }
                              />
                              <Button
                                dense
                                raised
                                disabled={!editStatus || !reportStatus.diffIndustry1}
                                className={classes.statusBtn}
                                onClick={() =>
                                  this.props.handleOpenModal(
                                    "industry1",
                                    reportStatus.industryParentId1,
                                    reportStatus.industryId1)}
                              >
                                選択
                              </Button>
                              <div style={{ marginTop: 5, fontSize: '1rem' }}>
                                {fmtIndustryName(
                                  industries,
                                  reportStatus.industryParentId1,
                                  reportStatus.industryId1)
                                }
                              </div>
                            </div>
                            <div style={{ marginLeft: 20, marginTop: 5, display: 'flex' }}>
                              <FormControlLabel
                                style={{ marginRight: 2 }}
                                control={
                                  <Checkbox
                                    checked={!!reportStatus.diffIndustry2}
                                    disabled={!editStatus}
                                    onChange={e =>
                                      this.props.changeReportStatus({
                                        diffIndustry2: e.target.checked
                                      })
                                    }
                                    style={{ height: 30 }}
                                  />
                                }
                              />
                              <Button
                                dense
                                raised
                                disabled={!editStatus || !reportStatus.diffIndustry2}
                                className={classes.statusBtn}
                                onClick={() =>
                                  this.props.handleOpenModal(
                                    "industry2",
                                    reportStatus.industryParentId2,
                                    reportStatus.industryId2)}
                              >
                                選択
                              </Button>
                              <div style={{ marginTop: 5, fontSize: '1rem' }}>
                                {fmtIndustryName(
                                  industries,
                                  reportStatus.industryParentId2,
                                  reportStatus.industryId2)
                                }
                              </div>
                            </div>
                            <div style={{ marginLeft: 20, marginTop: 5, display: 'flex' }}>
                              <FormControlLabel
                                style={{ marginRight: 2 }}
                                control={
                                  <Checkbox
                                    checked={!!reportStatus.diffIndustry3}
                                    disabled={!editStatus}
                                    onChange={e =>
                                      this.props.changeReportStatus({
                                        diffIndustry3: e.target.checked
                                      })
                                    }
                                    style={{ height: 30 }}
                                  />
                                }
                              />
                              <Button
                                dense
                                raised
                                disabled={!editStatus || !reportStatus.diffIndustry3}
                                className={classes.statusBtn}
                                onClick={() =>
                                  this.props.handleOpenModal(
                                    "industry3",
                                    reportStatus.industryParentId3,
                                    reportStatus.industryId3)}
                              >
                                選択
                              </Button>
                              <div style={{ marginTop: 5, fontSize: '1rem' }}>
                                {fmtIndustryName(
                                  industries,
                                  reportStatus.industryParentId3,
                                  reportStatus.industryId3)
                                }
                              </div>
                            </div>
                          </div>
                        )}
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell />
                          <CBodyCell />
                        </Fragment>
                      )}
                      <CBodyCell align="center">
                        {reportStatus.isFinish() && (
                          <div>
                           <Button
                            className={classes.pdfButton}
                            disabled={editStatus}
                            onClick={() =>
                              window.open(
                                `${baseApiUrl()}/${pathRole()}/result_index_report/${surveyId}/pdf.pdf?debug=false&token=${storage.getToken()}`
                              )
                            }
                          >
                            <i className="material-icons">picture_as_pdf</i>
                          </Button>
                           {isAdmin() && (
                          <Button
                            className={classes.exportCSV}
                            disabled={editStatus}
                            onClick={getCSV(survey.id)}
                             style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: editStatus ? 'not-allowed' : 'pointer',
                              border: 'none',
                              padding: '6px 12px',
                              borderRadius: '4px',
                              backgroundColor: 'transparent',
                            }}
                          >
                         <img
                              src="/csv.png"
                              alt="CSV"
                              style={{
                                width: '20px',
                                height: '20px',
                                filter: editStatus ? 'grayscale(100%)' : 'none',
                                opacity: editStatus ? 0.5 : 1,
                              }}
                            />
                          </Button>
                           )}
                          </div>
                        )}
                      </CBodyCell>
                    </CTableRow>
                    <CTableRow>
                      <CBodyCell className={classes.chapter}>
                        ４．自由記入一覧
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell />
                          <CBodyCell />
                        </Fragment>
                      )}
                      <CBodyCell />
                    </CTableRow>
                    <CTableRow>
                      <CBodyCell className={classes.chapter}>
                        <div style={{ marginLeft: 30 }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {reportStatus.isFinish() ? (
                              <Link
                                to={`/${pathRole()}/free_opinion_1_report/${surveyId}`}
                              >
                                自由記入１
                              </Link>
                            ) : (
                              <span>自由記入１</span>
                            )}
                            {isAdmin() && (
                              <Select
                                style={{ marginLeft: 10 }}
                                disabled={!editStatus}
                                value={reportStatus.freeInput1}
                                onChange={e =>
                                  this.props.changeReportStatus({
                                    freeInput1: e.target.value
                                  })
                                }
                                input={
                                  <CInput
                                    name="diff-time"
                                    id="diff-time"
                                    className={classes.industryInput}
                                  />
                                }
                              >
                                {surveyAttrs.map(item => (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            )}
                          </div>
                        </div>
                      </CBodyCell>
                      {isAdmin() && (
                        <Fragment>
                          <CBodyCell>
                            {latestUpdateHistory[4] &&
                              latestUpdateHistory[4].updateAdmin.adminName}
                          </CBodyCell>
                          <CBodyCell center>
                            {latestUpdateHistory[4] &&
                              moment(latestUpdateHistory[4].updateDt).format(
                                "YYYY/MM/DD"
                              )}
                          </CBodyCell>
                        </Fragment>
                      )}
                      <CBodyCell align="center">
                        {reportStatus.isFinish() && (
                          <Button
                            className={classes.pdfButton}
                            disabled={editStatus}
                            onClick={() =>
                              window.open(
                                `${baseApiUrl()}/${pathRole()}/free_opinion_1_report/${surveyId}/pdf.pdf?debug=false&token=${storage.getToken()}`
                              )
                            }
                          >
                            <i className="material-icons">picture_as_pdf</i>
                          </Button>
                        )}
                      </CBodyCell>
                    </CTableRow>
                    {survey.freeCommentCheck2 && (
                      <CTableRow>
                        <CBodyCell className={classes.chapter}>
                          <div style={{ marginLeft: 30 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              {reportStatus.isFinish() ? (
                                <Link
                                  to={`/${pathRole()}/free_opinion_2_report/${surveyId}`}
                                >
                                  自由記入２
                                </Link>
                              ) : (
                                <span>自由記入２</span>
                              )}
                              {isAdmin() && (
                                <Select
                                  style={{ marginLeft: 10 }}
                                  disabled={!editStatus}
                                  value={reportStatus.freeInput2}
                                  onChange={e =>
                                    this.props.changeReportStatus({
                                      freeInput2: e.target.value
                                    })
                                  }
                                  input={
                                    <CInput
                                      name="diff-time"
                                      id="diff-time"
                                      className={classes.industryInput}
                                    />
                                  }
                                >
                                  {surveyAttrs.map(item => (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              )}
                            </div>
                          </div>
                        </CBodyCell>
                        {isAdmin() && (
                          <Fragment>
                            <CBodyCell>
                              {latestUpdateHistory[5] &&
                                latestUpdateHistory[5].updateAdmin.adminName}
                            </CBodyCell>
                            <CBodyCell center>
                              {latestUpdateHistory[5] &&
                                moment(latestUpdateHistory[5].updateDt).format(
                                  "YYYY/MM/DD"
                                )}
                            </CBodyCell>
                          </Fragment>
                        )}
                        <CBodyCell align="center">
                          {reportStatus.isFinish() && (
                            <Button
                              className={classes.pdfButton}
                              disabled={editStatus}
                              onClick={() =>
                                window.open(
                                  `${baseApiUrl()}/${pathRole()}/free_opinion_2_report/${surveyId}/pdf.pdf?debug=false&token=${storage.getToken()}`
                                )
                              }
                            >
                              <i className="material-icons">picture_as_pdf</i>
                            </Button>
                          )}
                        </CBodyCell>
                      </CTableRow>
                    )}
                  </CTableBody>
                </CTable>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            {
              surveyAttrs.map((attr, attrIndex) => {
                let empty = false;
                let generated = false;
                attr.items.forEach((attrData) => {
                  if (attrData[2] === 1) {
                    empty = true;
                  }
                  if (attrData[4] === 1) {
                    generated = true;
                  }
                });
                return (
                  <ExpansionPanel
                    style={
                    {
                      // eslint-disable-next-line no-nested-ternary
                      display: isAdmin() ? generated ? 'block' : 'none' : empty ? 'block' : 'none'
                    }
                  }
                  >
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} >
                      {attr.name}
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                      style={
                        { display: 'block' }
                    }
                    >
                      {
                        attr.items.map((val, itemIndex) => {
                          return (
                            <div
                              style={
                                // eslint-disable-next-line no-nested-ternary
                                { display: isAdmin() ? !!val[4] === true ? 'flex' : 'none ' : val[2] ? 'flex' : 'none' }
                              }
                            >
                              <Checkbox
                                style={
                                  {
                                    display: isAdmin() ? 'block' : 'none',
                                    marginTop: '10px'
                                  }
                                }
                                disabled={!editStatus}
                                checked={val[2] === 1}
                                onChange={e => {
                                    this.props.changeAttrShowStatus(
                                      { id: val[0], attrIndex, itemIndex }
                                      , e.target.checked
                                      );
                                  }
                                }
                                color="primary"
                              />
                              <ExpansionPanel style={{ width: '950px' }}>
                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} >
                                  {val[1]}
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                  <CTable>
                                    <CTableHead>
                                      <CTableRow>
                                        <CHeadCell>目次</CHeadCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CHeadCell style={{ width: 140 }}>更新者</CHeadCell>
                                            <CHeadCell style={{ width: 160 }}>更新日</CHeadCell>
                                          </Fragment>
                                        )}
                                        <CHeadCell style={{ width: 100 }}>レポート出力</CHeadCell>
                                      </CTableRow>
                                    </CTableHead>
                                    <CTableBody>
                                      <CTableRow>
                                        <CBodyCell className={classes.reportName}>
                                          {reportStatus.isFinish() ? (
                                            <HashLink to={`/${pathRole()}/report_detail/${surveyId}?attr_item=${val[0]}`}>
                                              NiserES 調査結果レポート
                                            </HashLink>
                                          ) : (
                                            <span>NiserES 調査結果レポート</span>
                                          )}
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell />
                                          </Fragment>
                                        )}

                                        <CBodyCell align="center">
                                          {reportStatus.isFinish() && (
                                            <Button
                                              className={classes.pdfButton}
                                              disabled={editStatus}
                                              onClick={() =>
                                                window.open(
                                                  `${baseApiUrl()}/${pathRole()}/report_detail/${surveyId}/pdf.pdf?attr_item_id=${val[0]}&debug=false&token=${storage.getToken()}`
                                                )
                                              }
                                            >
                                              <i className="material-icons">picture_as_pdf</i>
                                            </Button>
                                          )}
                                        </CBodyCell>
                                      </CTableRow>
                                      <CTableRow>
                                        <CBodyCell className={classes.chapter}>
                                          {reportStatus.isFinish() ? (
                                            <HashLink
                                              to={`/${pathRole()}/report_detail/${surveyId}?attr_item=${val[0]}#description`}
                                            >
                                              １．調査概要
                                            </HashLink>
                                          ) : (
                                            <span>１．調査概要</span>
                                          )}
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell />
                                          </Fragment>
                                        )}

                                        <CBodyCell />
                                      </CTableRow>
                                      <CTableRow>
                                        <CBodyCell className={classes.chapter}>
                                          {reportStatus.isFinish() ? (
                                            <HashLink
                                              to={`/${pathRole()}/report_detail/${surveyId}?attr_item=${val[0]}#summary`}
                                            >
                                              ２．結果のまとめ
                                            </HashLink>
                                          ) : (
                                            <span>２．結果のまとめ</span>
                                          )}
                                        </CBodyCell>
                                      {isAdmin() ? (
                                        val[21] && val[21].detailComment ? (
                                          <Fragment>
                                            <CBodyCell>
                                              {val[21].detailComment.updateAdmin.adminName}
                                            </CBodyCell>
                                            <CBodyCell center>
                                              {moment(val[21].detailComment.updateDt).format("YYYY/MM/DD")}
                                            </CBodyCell>
                                          </Fragment>
                                        ) : (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell center />
                                          </Fragment>
                                        )
                                      ) : null}
                                        <CBodyCell />
                                      </CTableRow>
                                      <CTableRow>
                                        <CBodyCell className={classes.chapter}>
                                          {reportStatus.isFinish() ? (
                                            <HashLink
                                              to={`/${pathRole()}/report_detail/${surveyId}?&attr_item=${val[0]}#overall_result`}
                                            >
                                              ３．全体の尺度別設問の結果
                                            </HashLink>
                                          ) : (
                                            <span>３．全体の尺度別設問の結果</span>
                                          )}
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell />
                                          </Fragment>
                                        )}
                                        <CBodyCell />
                                      </CTableRow>
                                      <CTableRow>
                                        <CBodyCell className={classes.chapter}>
                                          {reportStatus.isFinish() ? (
                                            <HashLink
                                              to={`/${pathRole()}/report_detail/${surveyId}?attr_item=${val[0]}#attr_result`}
                                            >
                                              ４．属性別尺度の結果
                                            </HashLink>
                                          ) : (
                                            <span>４．属性別尺度の結果</span>
                                          )}
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell />
                                          </Fragment>
                                        )}
                                        <CBodyCell />
                                      </CTableRow>
                                      <CTableRow>
                                        <CBodyCell className={classes.reportName}>
                                          {/* <Link to="/member/list">NiserES 調査結果 添付資料</Link> */}
                                          NiserES 調査結果 添付資料
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell />
                                          </Fragment>
                                        )}
                                        <CBodyCell />
                                      </CTableRow>
                                      <CTableRow>
                                        <CBodyCell className={classes.chapter}>
                                          {reportStatus.isFinish() ? (
                                            <Link to={`/${pathRole()}/basic_report/${surveyId}?attr_item=${val[0]}`}>
                                              １．属性別集計結果 Q1~Q63
                                            </Link>
                                          ) : (
                                            <span>１．属性別集計結果 Q1~Q63</span>
                                          )}
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell />
                                          </Fragment>
                                        )}
                                        <CBodyCell align="center">
                                          {reportStatus.isFinish() && (
                                            <Button
                                              className={classes.pdfButton}
                                              disabled={editStatus}
                                              onClick={() =>
                                                window.open(
                                                  `${baseApiUrl()}/${pathRole()}/basic_report/${surveyId}/pdf.pdf?&attr_item_id=${val[0]}&debug=false&token=${storage.getToken()}`
                                                )
                                              }
                                            >
                                              <i className="material-icons">picture_as_pdf</i>
                                            </Button>
                                          )}
                                        </CBodyCell>
                                      </CTableRow>
                                      {survey.additionCount > 0 && (
                                        <CTableRow>
                                          <CBodyCell className={classes.chapter}>
                                            {reportStatus.isFinish() ? (
                                              <Link to={`/${pathRole()}/original_report/${surveyId}?attr_item=${val[0]}`}>
                                                ２．属性別集計結果 Q64~
                                              </Link>
                                            ) : (
                                              <span>２．属性別集計結果 Q64~</span>
                                            )}
                                          </CBodyCell>
                                          {isAdmin() && (
                                            <Fragment>
                                              <CBodyCell />
                                              <CBodyCell />
                                            </Fragment>
                                          )}
                                          <CBodyCell align="center">
                                            {reportStatus.isFinish() && (
                                              <Button
                                                className={classes.pdfButton}
                                                disabled={editStatus}
                                                onClick={() =>
                                                  window.open(
                                                    `${baseApiUrl()}/${pathRole()}/original_report/${surveyId}/pdf.pdf?attr_item_id=${val[0]}&debug=false&token=${storage.getToken()}`
                                                  )
                                                }
                                              >
                                                <i className="material-icons">picture_as_pdf</i>
                                              </Button>
                                            )}
                                          </CBodyCell>
                                        </CTableRow>
                                      )}
                                      <CTableRow>
                                        <CBodyCell className={classes.chapter}>
                                          {reportStatus.isFinish() ? (
                                            <Link
                                              to={`/${pathRole()}/result_index_report/${surveyId}?attr_item_id=${val[0]}`}
                                            >
                                              ３．質問別結果指数 一覧
                                            </Link>
                                          ) : (
                                            <span>３．質問別結果指数 一覧</span>
                                          )}
                                          {isAdmin() && (
                                            <div style={{ marginLeft: 10, fontSize: '0.8rem' }}>
                                              <div style={{ marginLeft: 20, marginTop: 5 }}>
                                                <FormControlLabel
                                                  control={
                                                    <Checkbox
                                                      checked={!!val[5]}
                                                      disabled={!editStatus}
                                                      onChange={e =>
                                                        this.props.changeReportByAttrStatus({
                                                          attrIndex,
                                                          itemIndex,
                                                          arr: 5,
                                                          val: e.target.checked
                                                        })
                                                      }
                                                      style={{ height: 30 }}
                                                    />
                                                  }
                                                  label="全体"
                                                />
                                              </div>

                                              <div style={{ marginTop: 10 }}>時系列:</div>
                                              <div style={{ display: 'flex' }}>
                                                <div style={{ marginLeft: 20, marginTop: 5 }}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={!!val[6]}
                                                        disabled={!editStatus}
                                                        onChange={e =>
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 6,
                                                            val: e.target.checked
                                                          })
                                                        }
                                                        style={{ height: 30 }}
                                                      />
                                                    }
                                                    label="１回前"
                                                  />
                                                </div>
                                                <div style={{ marginLeft: 20, marginTop: 5 }}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={!!val[7]}
                                                        disabled={!editStatus}
                                                        onChange={e =>
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 7,
                                                            val: e.target.checked
                                                          })
                                                        }
                                                        style={{ height: 30 }}
                                                      />
                                                    }
                                                    label="２回前"
                                                  />
                                                </div>
                                                <div style={{ marginLeft: 20, marginTop: 5 }}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={!!val[8]}
                                                        disabled={!editStatus}
                                                        onChange={e =>
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 8,
                                                            val: e.target.checked
                                                          })
                                                        }
                                                        style={{ height: 30 }}
                                                      />
                                                    }
                                                    label="３回前"
                                                  />
                                                </div>
                                              </div>

                                              <div style={{ marginTop: 10 }}>業種:</div>
                                              <div style={{ display: 'flex' }}>
                                                <div style={{ marginLeft: 20 }}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={!!val[9]}
                                                        disabled={!editStatus}
                                                        onChange={e =>
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 9,
                                                            val: e.target.checked
                                                          })
                                                        }
                                                        style={{ height: 30 }}
                                                      />
                                                    }
                                                    label="製造業"
                                                  />
                                                </div>
                                                <div style={{ marginLeft: 20 }}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={!!val[10]}
                                                        disabled={!editStatus}
                                                        onChange={(e) => {
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 10,
                                                            val: e.target.checked
                                                          });
                                                        }}
                                                        style={{ height: 30 }}
                                                      />
                                                    }
                                                    label="非製造業"
                                                  />
                                                </div>
                                              </div>

                                              <div style={{ marginTop: 10 }}>企業規模:</div>
                                              <div style={{ display: 'flex' }}>
                                                <div style={{ marginLeft: 20 }}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={!!val[14]}
                                                        disabled={!editStatus}
                                                        onChange={(e) => {
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 14,
                                                            val: e.target.checked
                                                          });
                                                        }}
                                                        style={{ height: 30 }}
                                                      />
                                                    }
                                                    label="大企業"
                                                  />
                                                </div>
                                                <div style={{ marginLeft: 20 }}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={!!val[15]}
                                                        disabled={!editStatus}
                                                        onChange={e =>
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 15,
                                                            val: e.target.checked
                                                          })
                                                        }
                                                        style={{ height: 30 }}
                                                      />
                                                    }
                                                    label="中小企業"
                                                  />
                                                </div>
                                              </div>

                                              <div style={{ marginTop: 10 }}>産業分類:</div>
                                              <div style={{ marginLeft: 20, marginTop: 5, display: 'flex' }}>

                                                <FormControlLabel
                                                  style={{ marginRight: 2 }}
                                                  control={
                                                    <Checkbox
                                                      checked={!!val[18]}
                                                      disabled={!editStatus}
                                                      onChange={e => {
                                                          const checked = e.target.checked;
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 18,
                                                            val: checked
                                                          });
                                                          if (!checked) {
                                                            this.props.changeReportByAttrStatus({
                                                              attrIndex,
                                                              itemIndex,
                                                              arr: 11,
                                                              val: "NULL"
                                                            });
                                                          }else if (val[11] === undefined || val[11] === null) {
                                                            this.props.changeReportByAttrStatus({
                                                              attrIndex,
                                                              itemIndex,
                                                              arr: 11,
                                                              val: "NULL"
                                                            });
                                                          }
                                                        }}
                                                        style={{ height: 30 }}
                                                    />
                                                  }
                                                />
                                                <Button
                                                  dense
                                                  raised
                                                  disabled={
                                                    !editStatus ||
                                                    !val[18]
                                                  }
                                                  className={classes.statusBtn}
                                                  onClick={() => {
                                                    const currentSub = val[11] === undefined || val[11] === null ? "NULL" : val[11];
                                                    this.props.handleOpenByAttrModal(
                                                      "industry1",
                                                      val[18],
                                                      currentSub,
                                                      {
                                                        attrIndex,
                                                        itemIndex
                                                      }
                                                      );
                                                    }
                                                  }
                                                >
                                                  選択
                                                </Button>
                                                <div style={{ marginTop: 5, fontSize: '1rem' }}>
                                                  {fmtIndustryName(
                                                    industries,
                                                    val[18],
                                                    val[11])
                                                  }
                                                </div>
                                              </div>
                                              <div style={{ marginLeft: 20, marginTop: 5, display: 'flex' }}>
                                                <FormControlLabel
                                                  style={{ marginRight: 2 }}
                                                  control={
                                                    <Checkbox
                                                      checked={!!val[19]}
                                                      disabled={!editStatus}
                                                       onChange={e => {
                                                          const checked = e.target.checked;
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 19,
                                                            val: checked
                                                          });
                                                          if (!checked) {
                                                            this.props.changeReportByAttrStatus({
                                                              attrIndex,
                                                              itemIndex,
                                                              arr: 12,
                                                              val: "NULL"
                                                            });
                                                          }else if (val[12] === undefined || val[12] === null) {
                                                            this.props.changeReportByAttrStatus({
                                                              attrIndex,
                                                              itemIndex,
                                                              arr: 12,
                                                              val: "NULL"
                                                            });
                                                          }
                                                        }}
                                                      style={{ height: 30 }}
                                                    />
                                                  }
                                                />
                                                <Button
                                                  dense
                                                  raised
                                                  disabled={
                                                    !editStatus ||
                                                    !val[19]
                                                  }
                                                  className={classes.statusBtn}
                                                  onClick={() => {
                                                    const currentSub = val[12] === undefined || val[12] === null ? "NULL" : val[12];
                                                    this.props.handleOpenByAttrModal(
                                                      "industry2",
                                                      val[19],
                                                      currentSub,
                                                      {
                                                        attrIndex,
                                                        itemIndex
                                                      }
                                                      );
                                                    }
                                                  }
                                                >
                                                  選択
                                                </Button>
                                                <div style={{ marginTop: 5, fontSize: '1rem' }}>
                                                  {fmtIndustryName(
                                                    industries,
                                                    val[19],
                                                    val[12])
                                                  }
                                                </div>
                                              </div>
                                              <div style={{ marginLeft: 20, marginTop: 5, display: 'flex' }}>
                                                <FormControlLabel
                                                  style={{ marginRight: 2 }}
                                                  control={
                                                    <Checkbox
                                                      checked={!!val[20]}
                                                      disabled={!editStatus}
                                                      onChange={e => {
                                                          const checked = e.target.checked;
                                                          this.props.changeReportByAttrStatus({
                                                            attrIndex,
                                                            itemIndex,
                                                            arr: 20,
                                                            val: checked
                                                          });
                                                          if (!checked) {
                                                            this.props.changeReportByAttrStatus({
                                                              attrIndex,
                                                              itemIndex,
                                                              arr: 13,
                                                              val: "NULL"
                                                            });
                                                          }else if (val[13] === undefined || val[13] === null) {
                                                              this.props.changeReportByAttrStatus({
                                                                attrIndex,
                                                                itemIndex,
                                                                arr: 13,
                                                                val: "NULL"
                                                              });
                                                            }
                                                          }}
                                                        style={{ height: 30 }}
                                                      />
                                                    }
                                                  />
                                                  <Button
                                                  dense
                                                  raised
                                                  disabled={
                                                    !editStatus ||
                                                    !val[20]
                                                  }
                                                  className={classes.statusBtn}
                                                  onClick={() => {
                                                   const currentSub = val[13] === undefined || val[13] === null ? "NULL" : val[13];
                                                    this.props.handleOpenByAttrModal(
                                                      "industry3",
                                                      val[20],
                                                      currentSub,
                                                      {
                                                        attrIndex,
                                                        itemIndex
                                                      }
                                                      );
                                                    }
                                                  }
                                                >
                                                  選択
                                                </Button>
                                                <div style={{ marginTop: 5, fontSize: '1rem' }}>
                                                  {fmtIndustryName(
                                                    industries,
                                                    val[20],
                                                    val[13])
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell />
                                          </Fragment>
                                        )}
                                        <CBodyCell align="center">
                                          {reportStatus.isFinish() && (
                                              <div>
                                            <Button
                                              className={classes.pdfButton}
                                              disabled={editStatus}
                                              onClick={() =>
                                                window.open(
                                                  `${baseApiUrl()}/${pathRole()}/result_index_report/${surveyId}/pdf.pdf?attr_item_id=${val[0]}&debug=false&token=${storage.getToken()}`
                                                )
                                              }
                                            >
                                              <i className="material-icons">picture_as_pdf</i>
                                            </Button>
                                                {isAdmin() && (
                                                    <Button
                                                        className={classes.exportCSV}
                                                        disabled={editStatus}
                                                        onClick={() => getAttrCSV(survey.id, val[0])}
                                                        style={{
                                                          display: 'flex',
                                                          flexDirection: 'column',
                                                          alignItems: 'center',
                                                          justifyContent: 'center',
                                                          cursor: editStatus ? 'not-allowed' : 'pointer',
                                                          border: 'none',
                                                          padding: '6px 12px',
                                                          borderRadius: '4px',
                                                          backgroundColor: 'transparent',
                                                        }}
                                                    >
                                                      <img
                                                          src="/csv.png"
                                                          alt="CSV"
                                                          style={{
                                                            width: '20px',
                                                            height: '20px',
                                                            filter: editStatus ? 'grayscale(100%)' : 'none',
                                                            opacity: editStatus ? 0.5 : 1,
                                                          }}
                                                      />
                                                    </Button>
                                                )}
                                              </div>
                                          )}
                                        </CBodyCell>
                                      </CTableRow>
                                      <CTableRow>
                                        <CBodyCell className={classes.chapter}>
                                          ４．自由記入一覧
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell />
                                            <CBodyCell />
                                          </Fragment>
                                        )}
                                        <CBodyCell />
                                      </CTableRow>
                                      <CTableRow>
                                        <CBodyCell className={classes.chapter}>
                                          <div style={{ marginLeft: 30 }}>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                              {reportStatus.isFinish() ? (
                                                <Link
                                                  to={`/${pathRole()}/free_opinion_1_report/${surveyId}?attr_item_id=${val[0]}`}
                                                >
                                                  自由記入１
                                                </Link>
                                              ) : (
                                                <span>自由記入１</span>
                                              )}
                                              {isAdmin() && (
                                                <Select
                                                  style={{ marginLeft: 10 }}
                                                  disabled={!editStatus}
                                                  value={Number(val[16])}
                                                  onChange={(e) => {
                                                    this.props.changeReportByAttrStatus({
                                                      attrIndex,
                                                      itemIndex,
                                                      arr: 16,
                                                      val: e.target.value
                                                      });
                                                    }
                                                  }
                                                  input={
                                                    <CInput
                                                      name="diff-time"
                                                      id="diff-time"
                                                      className={classes.industryInput}
                                                    />
                                                  }
                                                >
                                                  {surveyAttrs.map(item => (
                                                    <MenuItem key={item.id} value={item.id}>
                                                      {item.name}
                                                    </MenuItem>
                                                  ))}
                                                </Select>
                                              )}
                                            </div>
                                          </div>
                                        </CBodyCell>
                                        {isAdmin() && (
                                          <Fragment>
                                            <CBodyCell>
                                              {latestUpdateHistory[4] &&
                                                latestUpdateHistory[4].updateAdmin.adminName}
                                            </CBodyCell>
                                            <CBodyCell center>
                                              {latestUpdateHistory[4] &&
                                                moment(latestUpdateHistory[4].updateDt).format(
                                                  "YYYY/MM/DD"
                                                )}
                                            </CBodyCell>
                                          </Fragment>
                                        )}
                                        <CBodyCell align="center">
                                          {reportStatus.isFinish() && (
                                            <Button
                                              className={classes.pdfButton}
                                              disabled={editStatus}
                                              onClick={() =>
                                                window.open(
                                                  `${baseApiUrl()}/${pathRole()}/free_opinion_1_report/${surveyId}/pdf.pdf?attr_item_id=${val[0]}&debug=false&token=${storage.getToken()}`
                                                )
                                              }
                                            >
                                              <i className="material-icons">picture_as_pdf</i>
                                            </Button>
                                          )}
                                        </CBodyCell>
                                      </CTableRow>
                                      {survey.freeCommentCheck2 && (
                                        <CTableRow>
                                          <CBodyCell className={classes.chapter}>
                                            <div style={{ marginLeft: 30 }}>
                                              <div style={{ display: "flex", alignItems: "center" }}>
                                                {reportStatus.isFinish() ? (
                                                  <Link
                                                    to={`/${pathRole()}/free_opinion_2_report/${surveyId}?attr_item_id=${val[0]}`}
                                                  >
                                                    自由記入２
                                                  </Link>
                                                ) : (
                                                  <span>自由記入２</span>
                                                )}
                                                {isAdmin() && (
                                                  <Select
                                                    style={{ marginLeft: 10 }}
                                                    disabled={!editStatus}
                                                    value={Number(val[17])}
                                                    onChange={(e) => {
                                                      this.props.changeReportByAttrStatus({
                                                        attrIndex,
                                                        itemIndex,
                                                        arr: 17,
                                                        val: e.target.value
                                                        });
                                                      }
                                                    }
                                                    input={
                                                      <CInput
                                                        name="diff-time"
                                                        id="diff-time"
                                                        className={classes.industryInput}
                                                      />
                                                    }
                                                  >
                                                    {surveyAttrs.map(item => (
                                                      <MenuItem key={item.id} value={item.id}>
                                                        {item.name}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                )}
                                              </div>
                                            </div>
                                          </CBodyCell>
                                          {isAdmin() && (
                                            <Fragment>
                                              <CBodyCell>
                                                {latestUpdateHistory[5] &&
                                                  latestUpdateHistory[5].updateAdmin.adminName}
                                              </CBodyCell>
                                              <CBodyCell center>
                                                {latestUpdateHistory[5] &&
                                                  moment(latestUpdateHistory[5].updateDt).format(
                                                    "YYYY/MM/DD"
                                                  )}
                                              </CBodyCell>
                                            </Fragment>
                                          )}
                                          <CBodyCell align="center">
                                            {reportStatus.isFinish() && (
                                              <Button
                                                className={classes.pdfButton}
                                                disabled={editStatus}
                                                onClick={() =>
                                                  window.open(
                                                    `${baseApiUrl()}/${pathRole()}/free_opinion_2_report/${surveyId}/pdf.pdf?attr_item_id=${val[0]}&debug=false&token=${storage.getToken()}`
                                                  )
                                                }
                                              >
                                                <i className="material-icons">picture_as_pdf</i>
                                              </Button>
                                            )}
                                          </CBodyCell>
                                        </CTableRow>
                                      )}
                                    </CTableBody>
                                  </CTable>
                                </ExpansionPanelDetails>
                              </ExpansionPanel>
                            </div>
                          );
                        })
                      }
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                );
              })
            }
          </div>
          <div>{isAdmin() && (
          <div className={classes.warning}>【要注意】重複した自由記述・アンケート結果は必ず削除依頼をすること</div>
          )}</div>
        </div>
      </Paper>
    );
  }
}
export default withStyles(styles)(Report);



// WEBPACK FOOTER //
// ./src/components/Report/index.jsx